import { isMobileDevice } from "../../../helpers/device-helper";
import { TLink } from "../../../types";
import Link from "../link/link";
import styles from "./breadcrumbs-list.module.less";

export type TBreadcrumbsListProps = {
  items: Array<Partial<TLink>>;
};

export const BreadcrumbsList = ({ items }: TBreadcrumbsListProps) => {
  const isMobile = isMobileDevice();
  const itemsToRender = isMobile ? items.slice(-2) : items;
  const itemsToRenderWithPlaceholderFirst =
    isMobile && items.length > 2 ? [{ title: "...", url: undefined }, ...itemsToRender] : itemsToRender;

  return (
    <ul className={styles.list}>
      {itemsToRenderWithPlaceholderFirst.map((item) => {
        return (
          <li key={item.title} className={[styles.listItem, "body-s"].join(" ")}>
            <span className={styles.separator}>{"/"}</span>
            <Link
              className={[item.url ? styles.link : styles.unlinked].join(" ")}
              title={item.title}
              url={item.url ?? undefined}
            />
          </li>
        );
      })}
    </ul>
  );
};
